import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import MonicaObject from './MonicaObject';

export default class Roof extends MonicaObject {
    lineView: SVGElement;

    roofView: SVGElement;

    stretchLines = [];

    /**
     * コンストラクタ
     */
    constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
      super(_itemInfo);
      // 移動不可
      this.moveOnMouseMove = false;
    }

    /**
     * リドロー
     */
    reCreateImage=() => {
      this.lineView.remove();
      this.createImage();
    }

    /**
     * ビューの作成
     */
    createImage() {
      let viewObj: Element;
      if (!this.spt) {
        viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
      } else {
        viewObj = this.spt.element;
      }

      // 辺
      this.stretchLines = [];
      this.lineView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.lineView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_lineGroup`);
      viewObj.appendChild(this.lineView);
      let line: marietta.webcad.item.parts.RoofLine;
      let i: number;
      for (i = 1; i <= this.itemInfo.dotList.length; i += 1) {
        line = new marietta.webcad.item.parts.RoofLine(this.lineView, i);
        line.roofObj = this as marietta.webcad.item.Roof;
        this.stretchLines.push(line);
      }
      for (i = 0; i < this.stretchLines.length; i += 1) {
        line = this.stretchLines[i];
        line.firstDot = this.itemInfo.dotList[i].point;
        if (i === this.stretchLines.length - 1) {
          line.secondDot = this.itemInfo.dotList[0].point;
        } else {
          line.secondDot = this.itemInfo.dotList[i + 1].point;
        }
      }

      if (!this.spt) {
        this.spt = new SVGSprite(viewObj);
      }
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();

      /*
        //中央原点になるよに、ドット変換
        this.convertDotsToCenter();
        */
    }

    /**
     * 現行のTransform
     */
    getCurrentTransform(): string {
      let retTransform: string = '';
      retTransform += `translate( ${this.itemInfo.x}, ${this.itemInfo.y} ) `;
      retTransform += `rotate( ${this.itemInfo.rotation} ) `;
      return retTransform;
    }

    /**
     * 頂点情報の取得
     */
    private getPointInfo(): marietta.webcad.collection.PointCollection[] {
      const dotList: marietta.webcad.collection.PointCollection[] = [];
      let point;
      let pointCollection: marietta.webcad.collection.PointCollection;
      for (let i = 0, len = this.itemInfo.dotList.length; i < len; i += 1) {
        point = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
        point = this.spt.localToGlobal(point);
        point.x = Math.round(point.x / marietta.webcad.WebCADGlobal.scaleSize);
        point.y = Math.round(point.y / marietta.webcad.WebCADGlobal.scaleSize);
        pointCollection = new marietta.webcad.collection.PointCollection(point.x, point.y);
        pointCollection.type = this.itemInfo.dotList[i].type;

        dotList.push(pointCollection);
      }
      return dotList;
    }

    /**
     * 保存用データ（ドットXML)
     */
    getPointXML(): Element[] {
      const pointNodeList = [];
      let pointNode;
      const dotList: marietta.webcad.collection.PointCollection[] = this.getPointInfo();

      for (let i = 0, len = dotList.length; i < len; i += 1) {
        pointNode = document.createElementNS(null, 'point');
        pointNode.setAttribute('index', String(i + 1));

        pointNode.setAttribute('x', String(dotList[i].x));
        pointNode.setAttribute('y', String(-(dotList[i].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
        // 寄せ切りの時のみ出力
        if (this.itemInfo.roof_type === 1) {
          pointNode.setAttribute('type', String(dotList[i].type));
        }
        pointNodeList.push(pointNode);
      }
      return pointNodeList;
    }

    /**
     * 子供を表示
     */
    showChildren=(): void => {
      for (let i: number = 0; i < this.stretchLines.length; i += 1) {
        this.stretchLines[i].show();
      }
    }

    /**
    * 子供を隠す
    */
    hideChildren=(): void => {
      for (let i: number = 0; i < this.stretchLines.length; i += 1) {
        this.stretchLines[i].hide();
      }
    }

    /**
     * 屋根形状を描画する
     */
    onDrawRoofDesign = (list) => {
      if (this.roofView !== undefined && this.roofView !== null) {
        this.roofView.remove();
      }

      // 該当屋根に引き当てる
      const info = [];
      for (let k = 0; k < list[0].length; k += 1) {
        if (this.itemInfo.guid === list[0][k].guid) {
          info.push(list[0][k]);
        }
      }

      // 前に描いたものを初期化
      this.roofView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.roofView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_roofGroup`);

      const self = this;
      // 形状を描く
      let count = 0;
      // let p1: marietta.core.Point;
      // let p2: marietta.core.Point;
      let tempDotList: marietta.webcad.collection.PointCollection[] = [];
      for (let i: number = 0; i < info.length; i += 1) {
        count += 1;
        tempDotList = [];
        for (let k: number = 0; k < info[i].points.length; k += 1) {
          tempDotList.push(new marietta.webcad.collection.PointCollection(info[i].points[k].x, -(info[i].points[k].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
        }
        tempDotList.push(new marietta.webcad.collection.PointCollection(info[i].points[0].x, -(info[i].points[0].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));

        // 屋根形状
        const pathFill = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathFill.setAttribute('fill', '#CCCCCC');
        pathFill.setAttribute('opacity', '0.5');
        pathFill.setAttribute('id', `roof_${self.itemInfo.guid}_${count}`);
        pathFill.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(tempDotList));
        this.roofView.appendChild(pathFill);

        const pathLine = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathLine.setAttribute('stroke', '#000000');
        pathLine.setAttribute('stroke-width', '3');
        pathLine.setAttribute('fill', 'none');
        pathLine.setAttribute('id', `roof_${self.itemInfo.guid}_${count}_l`);
        pathLine.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(tempDotList));
        this.roofView.appendChild(pathLine);
      }
      count = 0;
      // 矢印
      for (let i: number = 0; i < info.length; i += 1) {
        count += 1;
        if (this.itemInfo.roof_type !== 3) {
          if (info[i].arrow.length >= 1) {
            // 矢印形状
            tempDotList = [];
            for (let k: number = 0; k < info[i].arrow.length; k += 1) {
              tempDotList.push(new marietta.webcad.collection.PointCollection(info[i].arrow[k].x, -(info[i].arrow[k].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
            }
            tempDotList.push(new marietta.webcad.collection.PointCollection(info[i].arrow[0].x, -(info[i].arrow[0].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));

            const arrowFill = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            arrowFill.setAttribute('stroke', '#000000');
            arrowFill.setAttribute('stroke-width', '3');
            arrowFill.setAttribute('fill', '#000000');
            arrowFill.setAttribute('id', `roofArrow_${self.itemInfo.guid}_${count}`);
            arrowFill.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(tempDotList));
            this.roofView.appendChild(arrowFill);
          }
        }
      }
      this.spt.element.appendChild(this.roofView);

      // ハイライト線を一番上に表示する
      const temp = this.lineView;
      const targetIndex = temp.parentElement.children.length - 1;
      const targetElement = temp.parentElement.children[targetIndex];
      targetElement.after(temp);
    }

    /**
     * カット、プラスアイテムが変更された
     */
    onChangeChildRoofShapeElement = () => {
      const self = this;
      // 屋根形状作成
      marietta.webcad.WebCADGlobal.cadAPIManager.getRoof(self.onDrawRoofDesign, self.onRoofApiFailed);
    }

    /**
     * 設定が変更された
     */
    onChangeSideSetting = (index: number, value: number) => {
      const self = this;
      if (self.itemInfo.dotList[index - 1].type === value) return;
      // 値の保持
      self.itemInfo.dotList[index - 1].type = value;

      // 屋根形状作成
      marietta.webcad.WebCADGlobal.cadAPIManager.getRoof(self.onDrawRoofDesign, self.onRoofApiFailed);
    }

    /**
     * 屋根の取得に失敗した
     */
    onRoofApiFailed = () => {
      console.log('onRoofApiFailed');
      const self = this;
      self.deleteMe();
    }

    /**
     * 屋根形状を描画ずみか否か
     */
    hasDrawing(): boolean {
      if (this.roofView === null || this.roofView === undefined) return false;
      return true;
    }

    /**
     * 頂点移動 XY
     */
    moveDots(x, y) {
      let i: number;
      for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
        this.itemInfo.dotList[i].x += x;
        this.itemInfo.dotList[i].y += y;
      }
      this.reCreateImage();
    }
}
